export default __webpack_public_path__ + "static/media/walkthru-upload.45e4eb39.svg";